export const DOMAIN = 'auth.customer';
